import type { TrialConfig } from '@zafroi/ui-kit';

/**
 * MAVK beta-trial configuration — single source of truth for the
 * platform-wide trial banner that runs across ERP, Engage and the
 * warehouse PWA.
 *
 * Encoded end-of-trial moment is 9 June 2026 00:00 IST (= 8 June
 * 2026 18:30 UTC); after that the banner disappears and the
 * subscription / paywall layer is expected to take over.
 */
export const MAVK_TRIAL: TrialConfig = {
  tenantName: 'MAVK',
  endDateIso: '2026-06-08T18:30:00.000Z',
  endDateLabel: '8 June 2026',
  renewalDateLabel: '9 June 2026',
};
